// src/lib/getLocaleFromLang.ts
import { LANGUAGES, DEFAULT_LANGUAGE } from "@/lib/languages";

/**
 * Strict mapping from Polylang code -> locale using your canonical config.
 * No guessing. Only fallback is DEFAULT_LANGUAGE (as defined in languages.ts).
 */
export function getLocaleFromLang(lang?: string): string {
  if (!lang) return DEFAULT_LANGUAGE.polylangLocale;

  const match = LANGUAGES.find((l) => l.polylangCode === lang);
  return match?.polylangLocale ?? DEFAULT_LANGUAGE.polylangLocale;
}
